import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=3c09a5a7&scoped=true&"
import script from "./PostAttachments.vue?vue&type=script&lang=js&"
export * from "./PostAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PostAttachments.vue?vue&type=style&index=0&id=3c09a5a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09a5a7",
  null
  
)

export default component.exports